
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import ModalIndex from './ModalIndex';

const AddiIndex = forwardRef((props, ref) => {
    const [modal, setModal] = useState(false);

    const toogle = () => {
        setModal(!modal)
    }

    return (
        <React.Fragment>        
            {modal && (
                <ModalIndex
                    //modal props
                    backdrop={"static"}
                    modal={modal}
                    toggle={toogle}

                    user={props.user}
                    price={props.price}
                    prices={props.prices}
                    discount_code={props.discount_code}
                    affiliate={props.affiliate}
                    reference={props.reference}
                />
            )}

            <button 
                className='btn-addi-form'
                onClick={() => toogle()}
            >
                Pagar con <span className='text-white'>Addi</span>
            </button>
        </React.Fragment>
    );
});


export default AddiIndex;